export const marginSize = (fontSize, bigMargin, smallMargin) => {
    if(fontSize >= 13){
        return bigMargin
    }else{
        return smallMargin
    }
}